export const UPDATE_TICKETS_FILTERS = "UPDATE_TICKETS_FILTERS";
export const SAVE_AUTH_TICKET__INFO = "SAVE_AUTH_TICKET__INFO";
